export default "__VITE_ASSET__ChbtTnf1__"